import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import rubricD from "../images/rubric_D.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The framework defines an `}<strong parentName="p">{`AI system`}</strong>{` as a machine-based system that can, for a given set of human-defined objectives,
make predictions, recommendations, or decisions influencing real or virtual environments. AI systems are designed
to operate with varying levels of autonomy.`}</p>
    <p>{`The framework classifies systems along four dimensions: context, input, model, and output. `}</p>
    <p><strong parentName="p">{`Context`}</strong>{` refers to the socio-economic environment in which the AI system is deployed. Core characteristics of this
dimension include the sector in which the system is deployed (e.g., healthcare, finance, defense), deployment impact
and scale, and whether the system performs a critical function.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Sector`}</strong>{`: The industrial sector in which the system is deployed.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Impact`}</strong>{`: Whether the system generates outcomes that present a risk or benefit to fundamental human rights, to individual well-being, or has no impact.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Criticality`}</strong>{`: Whether the system performs a critical activity, where critical activities are those for which the interruption of would mean serious consequences for the health, safety, and security of citizens or the effective functioning of services essential to the economy, society, or government.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`End user`}</strong>{`: Whether the intended user of the system in current deployment context is an AI expert or system developer, a trained practitioner who is not an AI expert, or an amateur.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Input`}</strong>{` refers to the input or data used by the AI system to build a representation of the environment. Core
characteristics of this dimension include data collection and characteristics (e.g., type, structure).`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Data collection`}</strong>{`: Whether data providing the system input is perceived from the environment by humans or by machines acting as sensors.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Data structure`}</strong>{`: Whether the structure of the data providing the system input is unstructured, semistructured, structured, or complex structured.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Model`}</strong>{` refers to the technical components that make up the AI system and represent "real world" processes. Core
characteristics of this dimension include model type and acquisition of capabilities.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Acquisition of capabilities`}</strong>{`: Whether the system's models acquire learning capabilities from expert knowledge, data, or system experience.`}</li>
    </ul>
    <p><strong parentName="p">{`Output`}</strong>{` refers to the tasks the system performs and the action it takes to influence the environment. Core
characteristics of this dimension include system task(s) and action autonomy.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Task`}</strong>{`: The tasks that the system performs, to include recognition, event detection, forecasting, personalization, interaction support, goal-driven optimization, or reasoning with knowledge structures.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Autonomy`}</strong>{`: The degree to which the system can evaluate input, make decisions, and act without human involvement.`}</p>
      </li>
    </ul>
    <div style={{
      "textAlign": "center"
    }}>
      <img src={rubricD} alt="Framework D explanatory diagram" style={{
        maxWidth: "800px"
      }} />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      